module.exports = __webpack_public_path__ + "static/img/detail_log.d1cebdf8.png";